import { forwardRef } from 'react';

import { BoxFlexProps } from './type';
import StyledBoxFlex from './styled';

const BoxFlex = forwardRef<HTMLDivElement, BoxFlexProps>(({ children, ...props }, ref) => {
  return (
    <StyledBoxFlex ref={ref} {...props}>
      {children}
    </StyledBoxFlex>
  );
});

export default BoxFlex;
